<div class="p-3">
    <h1 mat-dialog-title>Add Check Type</h1>
    <div class="row my-3">
        <div mat-dialog-content [formGroup]="form">
            <div class="d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Partner<span class="required-input">*</span></mat-label>
                    <mat-select formControlName="partner_id" (selectionChange)="sortByPartner($event.value)">
                        <mat-option *ngFor="let partner of partners" [value]="partner.id">
                            {{ partner.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('partner_id')?.invalid">Required</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Check Types<span class="required-input">*</span></mat-label>
                    <mat-select formControlName="check_types" multiple [disabled]="!form.get('partner_id')?.value">
                        <mat-option *ngFor="let checkType of availablePartnerCheckTypes" [value]="checkType">
                            {{ checkType.display_text }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('check_type_id')?.invalid">Required</mat-error>
                </mat-form-field>
                <div *ngIf="noAvailableCheckTypes" class="mb-3 ml-2 red">
                    *No Available Check Type(s) Available for Partner
                </div>
            </div>
        </div>
    </div>
    <div class="my-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" mat-dialog-close>
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button" [disabled]="!canCreateCheckType()" (click)="submitCheckType()">
            <mat-icon>check</mat-icon>
            Submit Check Type
        </button>
    </div>
    @if(!canCreateCheckType()) {
        <div class="my-3">
            <mat-action-row class="mt-4 d-flex justify-content-end">
                <div class="d-flex justify-content-end align-items-center text-muted">
                    <span class="required-input">*</span>&nbsp;- Required
                </div>
            </mat-action-row>
        </div>
    }
</div>